import React, { useEffect } from "react";
import {
  onBlankLayout,
  onHomeLayout,
  onCustomLayout,
} from "store/slices/themeSlice";
import { useDispatch } from "react-redux";

const AppRoute = ({
  component: Component,
  routeKey,
  blankLayout,
  homeLayout,
  customLayout,
  ...props
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const isBlank = blankLayout ? true : false;
    dispatch(onBlankLayout(isBlank));
  }, [blankLayout]);

  useEffect(() => {
    const isHome = homeLayout ? true : false;
    dispatch(onHomeLayout(isHome));
  }, [homeLayout]);

  useEffect(() => {
    const isCustom = customLayout ? true : false;
    dispatch(onCustomLayout(isCustom));
  }, [customLayout]);

  return <Component {...props} />;
};

export default AppRoute;
